import { useState } from "react";
import useJoyStickNavigation, {
  joystickEvent,
} from "hooks/UseJoyStickNavigation";
import { characters } from "utilities/characters";
import { NavigationAudio } from "./useNavigationAudio";

export interface NavigationState {
  backSelected: boolean;
  endQuizSelected: boolean;
  topSelected: boolean;
  eventCounter: number;
}

interface UseUserInfoNavigationProps {
  audio: NavigationAudio;
  currentPosition: number;
  setCurrentPosition: React.Dispatch<React.SetStateAction<number>>;
  onNavigateBack?: () => void;
  onEnter: () => void;
  setEndQuizModal: React.Dispatch<React.SetStateAction<boolean>>;
  canNavigateBack?: boolean;
  totalAmount?: number;
}

export default function useUserInfoNavigation({
  audio,
  currentPosition,
  setCurrentPosition,
  onNavigateBack,
  onEnter,
  setEndQuizModal,
  canNavigateBack = false,
  totalAmount,
}: UseUserInfoNavigationProps): NavigationState {
  const [backSelected, setBackSelected] = useState(false);
  const [endQuizSelected, setEndQuizSelected] = useState(false);
  const [topSelected, setTopSelected] = useState(false);
  const [eventCounter, setEventCounter] = useState(0);

  const handleJoyStick = (event: joystickEvent) => {
    setEventCounter((prev) => prev + 1);

    switch (event) {
      case "left":
        audio.select.play();
        if (!topSelected) {
          if (currentPosition === 0) return;
          setCurrentPosition((prev) => prev - 1);
        } else if (topSelected && canNavigateBack) {
          setBackSelected(true);
          setEndQuizSelected(false);
        }
        break;

      case "right":
        audio.select.play();
        if (!topSelected) {
          if (currentPosition === (totalAmount || characters.length) - 1)
            return;
          setCurrentPosition((prev) => prev + 1);
        } else {
          setBackSelected(false);
          setEndQuizSelected(true);
        }
        break;

      case "up":
        audio.menu.play();
        setTopSelected(true);
        if (canNavigateBack) {
          setBackSelected(true);
        } else {
          setEndQuizSelected(true);
        }
        break;

      case "down":
        if (topSelected) {
          setTopSelected(false);
          setBackSelected(false);
          setEndQuizSelected(false);
        }
        break;

      case "enter":
        if (!topSelected) {
          onEnter();
        } else if (topSelected) {
          if (backSelected && onNavigateBack) {
            onNavigateBack();
          } else if (endQuizSelected) {
            setEndQuizModal(true);
          }
        }
        break;

      default:
        break;
    }
  };

  useJoyStickNavigation(handleJoyStick);

  return {
    backSelected,
    endQuizSelected,
    topSelected,
    eventCounter,
  };
}
